import { el, editable } from './domUtils';

export default class DocListTool {
  static get toolbox() {
    return {
      title: 'Ҳужжатлар рўйхати',
      icon: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    };
  }

  static get sanitize() {
    return { items: {} };
  }

  constructor({ data }) {
    this.data = { items: data.items?.length ? data.items : [''] };
  }

  render() {
    this.list = el('div', { class: 'at-rows' });
    this.data.items.forEach((item) => this.addRow(item));
    const addBtn = el('button', { type: 'button', class: 'at-add-btn', onclick: () => this.addRow('') }, ['+ Ҳужжат қўшиш']);
    return el('div', { class: 'at-block at-doc-list' }, [
      el('div', { class: 'at-block-label' }, ['Ҳужжатлар рўйхати']),
      this.list,
      addBtn,
    ]);
  }

  addRow(value) {
    const text = editable(value, 'Ҳужжат номи...');
    const removeBtn = el('button', { type: 'button', class: 'at-remove-btn' }, ['×']);
    const row = el('div', { class: 'at-row-item' }, [text, removeBtn]);
    removeBtn.addEventListener('click', () => {
      if (this.list.children.length > 1) row.remove();
    });
    this.list.appendChild(row);
  }

  save() {
    return {
      items: Array.from(this.list.children)
        .map((row) => row.firstChild.innerHTML.trim())
        .filter(Boolean),
    };
  }
}
